import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUmbrella03 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.25 21.9593L12 12M17 3.33977C12.6868 0.849552 7.28964 1.93765 4.246 5.68296C3.94893 6.04852 3.80039 6.2313 3.75718 6.49318C3.7228 6.70154 3.77373 6.97767 3.88018 7.16006C4.01398 7.38929 4.25111 7.5262 4.72539 7.80002L19.2746 16.2C19.7489 16.4738 19.986 16.6108 20.2514 16.612C20.4626 16.613 20.7272 16.519 20.8905 16.3851C21.0957 16.2167 21.1797 15.9967 21.3477 15.5567C23.0695 11.0481 21.3132 5.82998 17 3.33977ZM17 3.33977C15.0868 2.2352 11.2973 5.2171 8.5359 10M17 3.33977C18.9132 4.44434 18.2255 9.2171 15.4641 14M22 22H2",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUmbrella03;
